var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifierApplocation(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_662_367)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.994,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234 0C248.667 0 263.333 0 278 0C378.269 12.5418 449.769 64.5418 492.5 156C502.796 181.184 509.296 207.184 512 234C512 248.667 512 263.333 512 278C499.458 378.269 447.458 449.769 356 492.5C330.816 502.796 304.816 509.296 278 512C263.333 512 248.667 512 234 512C133.731 499.458 62.2312 447.458 19.5 356C9.20393 330.816 2.70393 304.816 0 278C0 263.333 0 248.667 0 234C12.5418 133.731 64.5418 62.2312 156 19.5C181.184 9.20393 207.184 2.70393 234 0Z",
    fill: "#7365E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.969 106C189.736 106 136 159.736 136 225.969C136.156 240.184 138.734 254.243 143.732 267.52L143.42 267.442C156.151 307.198 219.025 369.056 255.891 406H255.969V405.922C286.117 375.774 333.527 327.427 356.88 290.874C362.113 282.595 366.253 274.706 368.596 267.442L368.205 267.52C373.204 254.243 375.859 240.184 375.937 225.969C375.937 159.736 322.28 106 255.969 106ZM255.969 179.809C281.431 179.809 302.129 200.507 302.129 225.969C302.129 251.431 281.431 272.129 255.969 272.129C230.507 272.051 209.887 251.431 209.887 225.969C209.809 200.507 230.507 179.887 255.969 179.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194,
    y: 162,
    width: 123,
    height: 123,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_662_367"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifierApplocation);
export default __webpack_public_path__ + "static/media/notifierApplocation.34962b42cca2f775674fd7408773da96.svg";
export { ForwardRef as ReactComponent };